module.exports = __webpack_public_path__ + "img/12_108.c396376c.png";